module.exports = __webpack_public_path__ + "static/media/study220404.420ee8c7.jpg";